import { inject, LOCALE_ID } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';

export const acceptLanguageInterceptor: HttpInterceptorFn = (req, next) => {
    const locale = inject(LOCALE_ID);

    const clone = req.clone({ setHeaders: { 'Accept-Language': locale } })

    return next(clone);
};
